import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class LookupValidators {
    static required: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        let result = null;

        if (control.value && typeof control.value === 'object') {
            result = (control.value.value || control.value.viewValue) ? null : { 'emptyLookup': true};
        }

        return result;
    };
};
